const halftoneBackground = (theme = `default`) => {
  const leftImage =
    theme === `default` ? `halftoneLeft` : `halftoneReversedLeft`
  const rightImage =
    theme === `default` ? `halftoneRight` : `halftoneReversedRight`
  const background =
    theme === `default` ? `g:headerFade` : `c:backgroundInverted`

  return {
    default: `repeat-y left 8px/235px i:${
      leftImage
    }, repeat-y right 8px/235px i:${rightImage}, ${background}`,
    mediumUp: `repeat-y left 16px/470px i:${
      leftImage
    }, repeat-y right 16px/470px i:${rightImage}, ${background}`,
  }
}

export default halftoneBackground



// WEBPACK FOOTER //
// ./src/components/styles/mixins/halftoneBackground.js